module.exports = __webpack_public_path__ + "media/images/sp/header/area-12ec02635d1fb180e047e97b6f422580.svg";